import {
  applyCollectionFilter,
  collectionFilterFromSearch,
} from "../../helpers/collectionFilter";

class QuickviewTrigger extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.button = this.closest("button");

    if (!this.button) return;

    this.button.addEventListener("mouseenter", () => {
      this._getData();
    });

    this.button.addEventListener("click", () => {
      console.log(`Open quickshop`, this.url);
      const detail = { target: "quickview-modal", html: this._getData() };

      if (this.setItemId) {
        detail.customData = this.setItemId;
      }

      // Dispatched from the button so the modal returns focus to something
      // focusable when it closes — this element isn't.
      this.button.dispatchEvent(
        new CustomEvent("markup-modal:open", {
          bubbles: true,
          detail,
        }),
      );
    });
  }

  disconnectedCallback() {}

  _getData() {
    const url = new URL(`${window.location.origin}${this.url}`);
    url.searchParams.set("section_id", this.sectionId);

    if (url.toString() === this.lastUrl) {
      if (this._data) return Promise.resolve(this._parseData(this._data));
      if (this.loadingData) return this.loadingData;
    }

    this.lastUrl = url.toString();

    this.loadingData = fetch(url)
      .then((res) => res.text())
      .then((data) => {
        this._data = data;

        return this._parseData(data);
      });

    return this.loadingData;
  }

  _parseData(data) {
    const section = new DOMParser().parseFromString(data, "text/html");
    const targetEl = document
      .createRange()
      .createContextualFragment(section.querySelector("body").innerHTML);

    // A card links through with its collection type's filter, which the
    // quickview should open on just as the PDP would.
    applyCollectionFilter(
      targetEl,
      collectionFilterFromSearch(
        new URL(this.url, window.location.origin).search,
      ),
    );

    if (this.quantity) {
      const quantityInput =
        targetEl.children[0].querySelector('[name="quantity"]');
      quantityInput.value = this.quantity;
    }

    return targetEl;
  }

  get url() {
    return this.getAttribute("url");
  }

  get sectionId() {
    return this.getAttribute("section-id") || "quickview";
  }

  get setItemId() {
    return this.getAttribute("set-item-id") || null;
  }

  get quantity() {
    return this.getAttribute("quantity") || null;
  }
}

if (!customElements.get("quickview-trigger")) {
  customElements.define("quickview-trigger", QuickviewTrigger);
}
